import React,{useState,useEffect, useRef} from 'react'
import { Navbar, Nav, Container, Row, Button,FormControl,Form,Col,Toast, Card, Jumbotron} from "react-bootstrap";
import axios from "axios"
import classes from "./App.module.css"
import { MdDirectionsWalk } from "react-icons/md";
import Stars from "react-star-ratings"
import ReviewPage from "./ReviewPage"

function Malls() {
    const [reload,setReload] = useState(false)
    const [Rest,setRest] = useState([]);
    const [currloc,setCurrloc] = useState({lat:"",lng:""})
    const [loc,setloc] = useState(true)
    const [curid,setCurid] = useState(false)
    const [showmodal,setShowmodal] = useState(false)
    
    useEffect(()=>{
        if (reload) {
            if (currloc.lat!==""&&currloc.lng!==""&&Rest.length===0) {
            console.log(currloc);
            axios.get(`https://places.ls.hereapi.com/places/v1/discover/search?in=${currloc.lat},${currloc.lng};r=1000&q=shoppingmalls&apiKey=QUiR_4fKktOIlI1oczow224IxdZCBUQsfnCIJ98NFO4`)
                .then((response)=>{
                console.log(response);
                setRest(response.data.results.items)
                })
                .catch(error =>{
                console.log(error);
                })
                setReload(false)
            }
        }
                if (loc) {
                    navigator.geolocation.getCurrentPosition(pos =>{
                        setCurrloc({lat: pos.coords.latitude, lng: pos.coords.longitude})
                        console.log(currloc);
                            setReload(true)
                            setloc(false)
                    })
                }
                
    },[loc,reload,Rest])

    return (
        
        <div onMouseEnter={()=>{setloc(true)}}>
            <ReviewPage show={showmodal} onHide={() => setShowmodal(false)} id={curid}/>
            <Container>
            <div align="center">
              <h2>Recreational Places nearby</h2>
              <hr style={{width:"150px",height:"2px",color:"white",backgroundColor:"black",borderRadius:"15%"}} />
            </div>
            <br/>
                <Row >
                {Rest && Rest.map((item,index)=>{
                    return(
                        <Col sm={12}>
                        <Card key={index} style={{marginBottom:"30px"}}>
                        <Card.Header closeButton={false}>
                        <strong className="mr-auto">{item.category.title}</strong>
                        </Card.Header>
                        <Card.Body>
                        <Row>
                        <Col md={4}>
                        <img src={item.icon} /><strong>{item.title}</strong>
                        <br/><br/>
                        </Col>
                        <Col md={{span:4,offset:4}}>
                            <Stars
                                rating={4.5}
                                starRatedColor="#FFB81C"
                                numberOfStars={5}
                                name='rating'
                                starDimension="40px"
                                starSpacing="10px"
                            ></Stars>
                        </Col>
                        </Row>
                        {item.openingHours&&item.openingHours.text.replace("<br/>","\n")}
                        <br/>
                        {item.vicinity&&item.vicinity.replace("<br/>","\n")}
                        <br/>
                        <br/>
                        <Row>
                        <Col md={{span:3}}>
                        {item.openingHours&&item.openingHours.isOpen? <div style={{color:"green"}}>Open Now</div>: <div style={{color:"red"}}>Closed</div>}
                        </Col>
                        <Col md={{span:4,offset:5}}>
                                <Button onClick={() => {setCurid(item.id); setShowmodal(true)}}>Give a Review</Button>
                        </Col>
                        </Row>
                        </Card.Body>
                    <Card.Footer>
                      <MdDirectionsWalk style={{fontSize:"1.5em"}}/>  {item.distance} m
                    </Card.Footer>
                    </Card>
                    </Col>
                    
                    )
                    })}
                 </Row>
            </Container>
        </div>
    )
}

export default Malls
